import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { RequirementType } from "@wingspanhq/wingspan-api-sdk";
import { queriesRequirements, queriesPayers } from "@query";
import { selectorCounterpartyDisplayName } from "../../../shared/selectors/selectorCounterpartyDisplayName";

export const CardTaxVerificationRequirementRequester = () => {
  const queryRequirements = queriesRequirements.listPayeeRequirements.useQuery(
    {}
  );

  const taxVerificationRequirements = (
    queryRequirements.data?.data ?? []
  ).filter(
    requirement =>
      requirement.type === RequirementType.TAX_VERIFICATION &&
      // A requirement now lists every engagement it is attached to; empty means
      // it is payee-level rather than engagement-level.
      (requirement.payeeEngagementIds?.length ?? 0) > 0
  );
  const hasTaxVerificationRequirement = taxVerificationRequirements.length > 0;

  const queryPayers = queriesPayers.listPayers.useQuery(
    {},
    { enabled: hasTaxVerificationRequirement }
  );

  // v1 named only the clients whose requirement demands tax verification. The
  // v3 instance regained `payerAccountId` (SDK 2.4.0), so the same narrowing
  // applies again; if no instance projects a payer id, every linked payer is
  // named instead of nobody (safe degradation).
  const requesterAccountIds = new Set(
    taxVerificationRequirements.map(requirement => requirement.payerAccountId)
  );
  const payers = queryPayers.data?.data ?? [];
  const requesterPayers = payers.filter(
    payer =>
      payer.payerAccountId && requesterAccountIds.has(payer.payerAccountId)
  );
  const payerNames = (requesterPayers.length ? requesterPayers : payers).map(
    payer => selectorCounterpartyDisplayName(payer)
  );

  return (
    <WSCard header="Taxpayer info">
      <WSText.ParagraphSm color="gray600">
        Complete your account setup by providing your taxpayer information below
        as required by {payerNames.join(", ")}
      </WSText.ParagraphSm>
    </WSCard>
  );
};
